module.exports = __webpack_public_path__ + "img/경기흐름.048ce8e0.svg";